import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Validator } from '../../utils/Validator.util';
import { namespace } from 'vuex-class';
import { AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_FORGOT_PASSWORD } from '../../store/authorization';

const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)


@Component
class Container extends Vue {

  rules: { require: any, email: any }
  dtError: any
  dtIsLoading: boolean;
  dtSuccess: boolean;

  dtForgotPassword: {
    action: "sendResetPwd",
    value: { email: string }
  }

  /**
   *
   */
  constructor() {
    super();
    this.dtError = null
    this.dtIsLoading = false
    this.dtSuccess = false
    this.rules = {
      require: (value: string) => !!value || 'Required.',
      email: (value: string) => Validator.IsValidEmail(value) || 'l\'email n\'est pas valide',
    }

    this.dtForgotPassword = {
      action: "sendResetPwd",
      value: { email: "" }
    }
  }
  get lblSetting() {
    return {
      ...require('@/locales/button').default,
      ...require('@/locales/login-form').default,
    }
  }
  get emailForgotPassword(): string {
    return this.dtForgotPassword.value.email
  }
  set emailForgotPassword(value: string) {
    this.dtForgotPassword.value.email = value;
  }


  @AuthorizationStore.Action(AUTHORIZATION_FORGOT_PASSWORD)
  storeForgotPassword: (payload: any) => Promise<any>;

  handleBacktoLogin() {
    this.$router.push('/')
  }

  _clearTimeout: any
  handleForgotPassword() {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      this.dtError = null;
      this.dtIsLoading = true
      this.storeForgotPassword(this.dtForgotPassword)
        .then(res => {
          this.dtSuccess = true
          this.dtIsLoading = false;
        })
        .catch(err => {
          this.dtIsLoading = false;
          this.dtError = err;
        })
    }, 300)
  }

  handleGotit() {
    this.dtError = null;
    this.dtSuccess = false;
    this.$router.push('/');
  }
}

export default Container;


// WEBPACK FOOTER //
// ./src/containers/forgot-password/index.ts